<template>
  <div class="border-radius notification__container">
    <div class="bg-light-grey-600 p-2 pt-3">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="heading-h4-18-semi txt-dark-high-contrast">{{ $t("notifications.notification") }}</h4>
        <p class="body-12-regular clickable notification__read-all" @click="markRead">
          {{ $t("notifications.markRead") }}
        </p>
      </div>
    </div>
    <PerfectScrollbar :options="settings" @scroll="onScroll" class="px-2 py-3 flex-grow-1 notification__scroll">
      <div class="d-flex justify-content-center align-items-center mt-1" v-if="isLoadingNoti">
        <GLoading size="small" />
      </div>
      <div class="d-flex flex-column align-items-center mt-1" v-else-if="!(listNoti.length + listPinnedNoti.length)">
        <svg xmlns="http://www.w3.org/2000/svg" width="92" height="64" viewBox="0 0 92 64" fill="none">
          <path d="M25 25H79C80.1046 25 81 25.8954 81 27V62C81 63.1046 80.1046 64 79 64H27C25.8954 64 25 63.1046 25 62V25Z" fill="#EBEEF1" />
          <path d="M25 22C25 20.8954 25.8954 20 27 20H47C48.1046 20 49 20.8954 49 22V28H25V22Z" fill="#EBEEF1" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M59.2184 15.7351C58.7611 15.9981 58.174 15.8405 57.9072 15.3831L55.2808 10.8817C55.0139 10.4244 55.1683 9.84041 55.6257 9.57742C56.083 9.31442 56.6701 9.47198 56.9369 9.92934L59.5633 14.4307C59.8302 14.8881 59.6758 15.4721 59.2184 15.7351Z" fill="#547AFF" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M65.57 6.75117C66.0989 6.75512 66.5275 7.18651 66.5273 7.71471L66.5259 13.0625C66.5258 13.5907 66.0969 14.0157 65.5681 14.0118C65.0392 14.0078 64.6106 13.5764 64.6107 13.0482L64.6122 7.70043C64.6123 7.17223 65.0412 6.74723 65.57 6.75117Z" fill="#547AFF" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M70.8693 15.1394C70.4102 14.8739 70.2508 14.2885 70.5133 13.8319L73.2272 9.10999C73.4897 8.65332 74.0747 8.4983 74.5338 8.76374C74.993 9.02917 75.1524 9.61456 74.8899 10.0712L72.1759 14.7931C71.9135 15.2498 71.3285 15.4048 70.8693 15.1394Z" fill="#547AFF" />
          <path d="M1.93652 1.89416C2.45376 1.89416 2.87307 1.47017 2.87307 0.947185C2.87307 0.424196 2.45376 0.000244141 1.93652 0.000244141C1.41929 0.000244141 1 0.424196 1 0.947185C1 1.47017 1.41929 1.89416 1.93652 1.89416Z" fill="#D9DADD" />
          <path d="M8.6436 1.89393C9.16084 1.89393 9.58013 1.46994 9.58013 0.946949C9.58013 0.423956 9.16084 0 8.6436 0C8.12636 0 7.70703 0.423956 7.70703 0.946949C7.70703 1.46994 8.12636 1.89393 8.6436 1.89393Z" fill="#D9DADD" />
          <path d="M15.3545 1.89393C15.8717 1.89393 16.291 1.46994 16.291 0.946949C16.291 0.423956 15.8717 0 15.3545 0C14.8373 0 14.418 0.423956 14.418 0.946949C14.418 1.46994 14.8373 1.89393 15.3545 1.89393Z" fill="#D9DADD" />
          <path d="M22.0615 1.89393C22.5788 1.89393 22.9981 1.46994 22.9981 0.946949C22.9981 0.423956 22.5788 0 22.0615 0C21.5443 0 21.125 0.423956 21.125 0.946949C21.125 1.46994 21.5443 1.89393 22.0615 1.89393Z" fill="#D9DADD" />
          <path d="M1.93653 7.26157C2.45377 7.26157 2.87308 6.83761 2.87308 6.31462C2.87308 5.79163 2.45377 5.36768 1.93653 5.36768C1.41929 5.36768 1 5.79163 1 6.31462C1 6.83761 1.41929 7.26157 1.93653 7.26157Z" fill="#D9DADD" />
          <path d="M8.6436 7.26157C9.16084 7.26157 9.58013 6.83761 9.58013 6.31462C9.58013 5.79163 9.16084 5.36768 8.6436 5.36768C8.12636 5.36768 7.70703 5.79163 7.70703 6.31462C7.70703 6.83761 8.12636 7.26157 8.6436 7.26157Z" fill="#D9DADD" />
          <path d="M15.3545 7.26229C15.8717 7.26229 16.2911 6.83834 16.2911 6.31535C16.2911 5.79236 15.8717 5.36841 15.3545 5.36841C14.8373 5.36841 14.418 5.79236 14.418 6.31535C14.418 6.83834 14.8373 7.26229 15.3545 7.26229Z" fill="#D9DADD" />
          <path d="M22.0615 7.26157C22.5788 7.26157 22.9981 6.83761 22.9981 6.31462C22.9981 5.79163 22.5788 5.36768 22.0615 5.36768C21.5443 5.36768 21.125 5.79163 21.125 6.31462C21.125 6.83761 21.5443 7.26157 22.0615 7.26157Z" fill="#D9DADD" />
          <path d="M1.93653 12.6297C2.45377 12.6297 2.87308 12.2058 2.87308 11.6828C2.87308 11.1598 2.45377 10.7358 1.93653 10.7358C1.41929 10.7358 1 11.1598 1 11.6828C1 12.2058 1.41929 12.6297 1.93653 12.6297Z" fill="#D9DADD" />
          <path d="M8.6436 12.6315C9.16084 12.6315 9.58013 12.2075 9.58013 11.6845C9.58013 11.1615 9.16084 10.7375 8.6436 10.7375C8.12636 10.7375 7.70703 11.1615 7.70703 11.6845C7.70703 12.2075 8.12636 12.6315 8.6436 12.6315Z" fill="#D9DADD" />
          <path d="M15.3545 12.6303C15.8717 12.6303 16.2911 12.2063 16.2911 11.6833C16.2911 11.1603 15.8717 10.7363 15.3545 10.7363C14.8373 10.7363 14.418 11.1603 14.418 11.6833C14.418 12.2063 14.8373 12.6303 15.3545 12.6303Z" fill="#D9DADD" />
          <path d="M22.0615 12.6315C22.5788 12.6315 22.9981 12.2075 22.9981 11.6845C22.9981 11.1615 22.5788 10.7375 22.0615 10.7375C21.5443 10.7375 21.125 11.1615 21.125 11.6845C21.125 12.2075 21.5443 12.6315 22.0615 12.6315Z" fill="#D9DADD" />
          <path d="M1.93653 17.9994C2.45377 17.9994 2.87308 17.5754 2.87308 17.0524C2.87308 16.5294 2.45377 16.1055 1.93653 16.1055C1.41929 16.1055 1 16.5294 1 17.0524C1 17.5754 1.41929 17.9994 1.93653 17.9994Z" fill="#D9DADD" />
          <path d="M8.6436 18.0001C9.16084 18.0001 9.58013 17.5761 9.58013 17.0531C9.58013 16.5302 9.16084 16.1062 8.6436 16.1062C8.12636 16.1062 7.70703 16.5302 7.70703 17.0531C7.70703 17.5761 8.12636 18.0001 8.6436 18.0001Z" fill="#D9DADD" />
          <path d="M15.3545 17.9996C15.8717 17.9996 16.2911 17.5756 16.2911 17.0527C16.2911 16.5297 15.8717 16.1057 15.3545 16.1057C14.8373 16.1057 14.418 16.5297 14.418 17.0527C14.418 17.5756 14.8373 17.9996 15.3545 17.9996Z" fill="#D9DADD" />
          <path d="M22.0615 18.0001C22.5788 18.0001 22.9981 17.5761 22.9981 17.0531C22.9981 16.5302 22.5788 16.1062 22.0615 16.1062C21.5443 16.1062 21.125 16.5302 21.125 17.0531C21.125 17.5761 21.5443 18.0001 22.0615 18.0001Z" fill="#D9DADD" />
          <path d="M25 28H79C80.1046 28 81 28.8954 81 30V62C81 63.1046 80.1046 64 79 64H27C25.8954 64 25 63.1046 25 62V28Z" fill="#DADFE4" />
          <path d="M25 25C25 23.8954 25.8954 23 27 23H47C48.1046 23 49 23.8954 49 25V28H25V25Z" fill="#DADFE4" />
          <line x1="25" y1="38.5" x2="81" y2="38.5" stroke="#EBEEF1" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M85.1948 52.203C85.1948 52.051 85.0721 51.9277 84.9207 51.9277C84.7694 51.9277 84.6467 52.051 84.6467 52.203V53.1866C84.6467 53.3386 84.7694 53.4619 84.9207 53.4619C85.0721 53.4619 85.1948 53.3386 85.1948 53.1866V52.203ZM84.183 54.2028C84.3344 54.2028 84.4571 54.0796 84.4571 53.9276C84.4571 53.7756 84.3344 53.6523 84.183 53.6523L83.2037 53.6523C83.0524 53.6523 82.9297 53.7756 82.9297 53.9276C82.9297 54.0796 83.0524 54.2028 83.2037 54.2028H84.183ZM86.6378 54.2028C86.7891 54.2028 86.9118 54.0796 86.9118 53.9276C86.9118 53.7756 86.7891 53.6523 86.6378 53.6523L85.6585 53.6523C85.5071 53.6523 85.3844 53.7756 85.3844 53.9276C85.3844 54.0796 85.5071 54.2028 85.6585 54.2028H86.6378ZM85.1948 54.6686C85.1948 54.5166 85.0721 54.3933 84.9207 54.3933C84.7694 54.3933 84.6467 54.5166 84.6467 54.6686V55.6522C84.6467 55.8042 84.7694 55.9274 84.9207 55.9274C85.0721 55.9274 85.1948 55.8042 85.1948 55.6522V54.6686Z" fill="#C3CACF" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2998 29.2105C17.2998 29.0458 17.1663 28.9124 17.0017 28.9124C16.837 28.9124 16.7035 29.0458 16.7035 29.2105V30.2311C16.7035 30.3957 16.837 30.5292 17.0017 30.5292C17.1663 30.5292 17.2998 30.3957 17.2998 30.2311V29.2105ZM16.2328 31.2981C16.3975 31.2981 16.5309 31.1646 16.5309 31C16.5309 30.8353 16.3975 30.7018 16.2328 30.7018L15.2122 30.7018C15.0475 30.7018 14.9141 30.8353 14.9141 31C14.9141 31.1646 15.0475 31.2981 15.2122 31.2981H16.2328ZM18.7911 31.2981C18.9558 31.2981 19.0893 31.1646 19.0893 31C19.0893 30.8353 18.9558 30.7018 18.7911 30.7018L17.7705 30.7018C17.6059 30.7018 17.4724 30.8353 17.4724 31C17.4724 31.1646 17.6059 31.2981 17.7705 31.2981H18.7911ZM17.2998 31.7688C17.2998 31.6042 17.1663 31.4707 17.0017 31.4707C16.837 31.4707 16.7035 31.6042 16.7035 31.7688V32.7894C16.7035 32.9541 16.837 33.0876 17.0017 33.0876C17.1663 33.0876 17.2998 32.9541 17.2998 32.7894V31.7688Z" fill="#C3CACF" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M86.698 8.21042C86.698 8.05268 86.5707 7.9248 86.4136 7.9248C86.2566 7.9248 86.1293 8.05268 86.1293 8.21042L86.1293 9.23102C86.1293 9.38877 86.2566 9.51664 86.4136 9.51664C86.5707 9.51664 86.698 9.38877 86.698 9.23102V8.21042ZM85.6481 10.2855C85.8052 10.2855 85.9325 10.1576 85.9325 9.99989C85.9325 9.84215 85.8052 9.71428 85.6481 9.71428L84.632 9.71428C84.475 9.71428 84.3477 9.84215 84.3477 9.99989C84.3477 10.1576 84.475 10.2855 84.632 10.2855H85.6481ZM88.1952 10.2855C88.3523 10.2855 88.4796 10.1576 88.4796 9.99989C88.4796 9.84215 88.3523 9.71428 88.1952 9.71428L87.1791 9.71428C87.0221 9.71428 86.8948 9.84215 86.8948 9.99989C86.8948 10.1576 87.0221 10.2855 87.1791 10.2855H88.1952ZM86.698 10.7688C86.698 10.611 86.5707 10.4831 86.4136 10.4831C86.2566 10.4831 86.1293 10.611 86.1293 10.7688L86.1293 11.7894C86.1293 11.9471 86.2566 12.075 86.4136 12.075C86.5707 12.075 86.698 11.9471 86.698 11.7894V10.7688Z" fill="#C3CACF" />
        </svg>
        <p class="paragraph-14-regular text-dark-subtext2 mt-3 text-center">You don’t have any notifications yet</p>
      </div>
      <div v-else>
        <div v-if="maxAllReaded" class="d-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path d="M10.25 0.25C4.73 0.25 0.25 4.73 0.25 10.25C0.25 15.77 4.73 20.25 10.25 20.25C15.77 20.25 20.25 15.77 20.25 10.25C20.25 4.73 15.77 0.25 10.25 0.25ZM8.25 15.25L3.25 10.25L4.66 8.84L8.25 12.42L15.84 4.83L17.25 6.25L8.25 15.25Z" fill="#00C753" />
          </svg>
          <span class="ml-1 txt-dark-high-contrast paragraph-14-regular">All caught up for you!</span>
        </div>
        <NotificationItem v-for="(noti, i) in listPinnedNoti" :key="`pin_${i}`" :notification="noti" pinned></NotificationItem>
        <NotificationItem v-for="(noti, i) in listNoti" :key="`normal_${i}`" :notification="noti"></NotificationItem>

        <div class="d-flex justify-content-center align-items-center mt-3 loading-more" v-if="isLoadingMoreNoti">
          <GLoading size="small" />
        </div>
        <div class="py-2 loading-done" v-if="loadedAll">
          <p class="typo-paragraph10 typo-regular text-light-disabled">{{ $t("generals.notiCenter.loaddone") }}</p>
        </div>
      </div>
    </PerfectScrollbar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import NotificationItem from "./NotificationItem.vue";

const NOTI_AUTO_POPUP_LOCAL_STORAGE = "NotiAutoOpenPopup";
const IMPORTANT_NOTI_AUTO_LOCAL_STORAGE = "ImportantNotiAutoOpen"
const REOPEN_NOTI_AUTO_POPUP_TIME = 2 * 60000; // Reopen after more than 6 hours

export default {
  name: "NewNotificationCenter",
  components: {
    NotificationItem
  },
  data: () => ({
    delayTimer: undefined,
    settings: {
      handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
      wheelPropagation: true,
      wheelSpeed: 0.6
    },
    totalLoaded: 0,
    marking: false
  }),
  computed: {
    ...mapGetters("notibar", {
      notiList: "noti",
      pinnedNotiList: "pinnedNoti",
      isLoadingNoti: "isLoadingNoti",
      isLoadingMoreNoti: "isLoadingMoreNoti",
      last_system_noti: "last_system_noti",
      noti_list_count: "noti_list_count",
      limit_pagination: "limit_pagination",
      notiAction: "noti_action"
    }),
    ...mapState("notibar", {
      maxAllReaded: state => state.notiBar.maxAllReaded
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    tabs() {
      return [
        {
          text: "Notification",
          key: "notification"
        },
        {
          text: "Notification",
          key: "notification"
        }
      ];
    },
    loadedAll() {
      return this.totalLoaded >= this.noti_list_count;
    },
    listNoti() {
      return this.notiList.filter(this.filterNoti);
    },
    listPinnedNoti() {
      return this.pinnedNotiList.filter(this.filterNoti);
    },
    noti() {
      if (this.last_system_noti && this.last_system_noti[0]) {
        return this.last_system_noti[0];
      }
      return undefined;
    }
  },
  async created() {
    await this.init();
  },
  methods: {
    ...mapActions("notibar", {
      showNotificationBar: "showNotificationBar",
      closeNotiCenter: "closeNotificationBar",
      closeNotiBar: "closeNotificationBar",
      loadNoti: "loadNoti",
      loadMoreNoti: "loadMoreNoti",
      showModalNoti: "showModalNoti",
      trackAction: "trackAction",
      closeNotiContent: "closeNotiContent",
      markAllAsRead: "markAllAsRead"
    }),
    ...mapActions("tutorial", {
      openStartedGuide: "openStartedGuide"
    }),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.letLoadMore();
      }
    },
    letLoadMore() {
      clearTimeout(this.delayTimer);
      if (this.loadedAll) {
        return;
      }
      if (this.isLoadingMoreNoti) {
        return;
      }
      let loaded = this.totalLoaded;
      this.delayTimer = setTimeout(() => {
        this.loadMoreNoti({
          loaded,
          onSuccess: () => {
            this.totalLoaded += this.limit_pagination;
          },
          onError: err => {
            this.gSnackbarCommit({
              message: typeof err == "object" ? err.toString() : err,
              type: "error"
            });
          }
        });
      }, 500);
    },
    markRead() {
      if (this.maxAllReaded == true || this.marking == true) {
        return;
      }
      this.markAllAsRead({
        onLoading: () => {
          this.marking = true;
          this.gSnackbarCommit({
            message: this.$t("status.processing"),
            type: "loading"
          });
        },
        onSuccess: () => {
          this.gSnackbarCommit({
            message: this.$t("notifications.markReadSuccess"),
            type: "success"
          });
          this.marking = false;
        },
        onError: err => {
          this.gSnackbarCommit({
            message: typeof err == "object" ? err.toString() : err,
            type: "error"
          });
          this.marking = false;
        }
      });
    },
    async init() {
      this.loadNoti({
        onSuccess: () => {
          this.totalLoaded += this.limit_pagination;
          this.openNotiAutomatically();
        },
        onError: err => {
          this.gSnackbarCommit({
            message: err,
            type: "error"
          });
        }
      });
    },
    filterNoti(e) {
      if (e.settings?.data) {
        try {
          const settingsJSON = JSON.parse(this.noti.settings.data);

          if (Object.keys(settingsJSON).length == 0) {
            return true;
          }
          
          if (settingsJSON["tag"] || settingsJSON["tagType"] || settingsJSON["hideTimeAgo"]) {
            return true;
          }

          if (settingsJSON["free"] && this.isDevStore) {
            return true;
          }

          if (settingsJSON[this.shopInfo.plan]) {
            return true;
          }

          return false;
        } catch (err) {
          // eslint-disable-next-line no-console
          console.warn({
            err,
            json: this.noti.settings.data
          });
        }
      }
      return true;
    },
    async openNotiAutomatically() {
      if (
        this.noti
        && (
          // open welcome back noti
          (this.noti.action == "welcome_back" && this.noti.state < 1)

          // old logic for auto open noti
          || (this.noti.state <= 1 && this.noti.action_count <= 1 && this.noti.action == "open_modal" && this.noti.is_important && new Date(this.noti.from_date) <= Date.now() && new Date(this.noti.to_date) >= Date.now())
        )
      ) {
        let autoOpenImporantNoti = window.localStorage.getItem(IMPORTANT_NOTI_AUTO_LOCAL_STORAGE);
        if (autoOpenImporantNoti) {
            autoOpenImporantNoti = JSON.parse(autoOpenImporantNoti);
        } else {
          autoOpenImporantNoti = {};
        }

        const notiId = this.noti.id;
        if (!autoOpenImporantNoti[notiId]) {
          this.openNotiModal(this.noti);
          autoOpenImporantNoti[notiId] = 1;
          window.localStorage.setItem(IMPORTANT_NOTI_AUTO_LOCAL_STORAGE, JSON.stringify(autoOpenImporantNoti));
        }
        return;
      } 

      // open noti has setting: auto_open_popup
      const allAutoOpenNotiString = localStorage.getItem(NOTI_AUTO_POPUP_LOCAL_STORAGE);
      let allAutoOpenNoti = {};
      if (allAutoOpenNotiString) {
        allAutoOpenNoti = JSON.parse(allAutoOpenNotiString);
      }

      const allNoti = [...this.notiList, ...this.pinnedNotiList]
        .map(item => {
          /**
           * Old logic: Use key in local storage is "id" of noti
           * New logic: Use key in local storage is "base_id" of noti
           */
          if (allAutoOpenNoti[item.id]) {
            allAutoOpenNoti[item.base_id] = allAutoOpenNoti[item.id];
            allAutoOpenNoti[item.id] = undefined; 
          }

          // if the user actively opens auto_open_noti, the number of openings will be counted
          if (item.action_count > 0) {
            item.settings.auto_open_popup -= item.action_count;
          }

          /**
           * All noti not from admin have same "base_id" = 0
           * Assign "base_id" of those is "id" to get "base_id" is unique
           */
          if (item.base_id == 0) {
            item.base_id = item.id;
          }

          /**
           * Hotfix: admin change "auto_open_popup"
           * "auto_open_popup" = the smaller number between "auto_open_popup" from API & "count" from Local Storage
           */
          if (
            item.settings.auto_open_popup > 0 // admin allow auto_open_popup
            && allAutoOpenNoti[item.base_id] // noti was opened automatically
            && allAutoOpenNoti[item.base_id].count < item.settings.auto_open_popup
          ) {
            item.settings.auto_open_popup = allAutoOpenNoti[item.base_id].count;
          }
          return item;
        })
        .sort((item1, item2) => {
          if (item1.settings.auto_open_popup && item2.settings.auto_open_popup) {
            const fromDate1 = new Date(item1.from_date);
            const fromDate2 = new Date(item2.from_date);
            return fromDate2.getTime() - fromDate1.getTime();
          } else if (item1.settings.auto_open_popup) {
            return -1;
          } else if (item2.settings.auto_open_popup) {
            return 1;
          } else {
            return 0;
          }
        });

      let autoOpenNoti = null;
      const now = new Date().getTime();

      for (const i in allNoti) {
        const item = allNoti[i];
        if (item.settings && item.settings.auto_open_popup > 0) {
          // if item was opened
          if (allAutoOpenNoti[item.base_id]) {
            // if it's been "REOPEN_NOTI_AUTO_POPUP_TIME" since last opened it => reopen it
            if (allAutoOpenNoti[item.base_id].count > 0 && now >= (allAutoOpenNoti[item.base_id].date + REOPEN_NOTI_AUTO_POPUP_TIME)) {
                autoOpenNoti = item;
                break; // end loop
            } // else move to next item

          } else if (item.settings.auto_open_popup) { // this is first time open it
            autoOpenNoti = item;
            break;
          }
        }
      }

      if (autoOpenNoti && autoOpenNoti.settings.auto_open_popup > 0) {
        allAutoOpenNoti[autoOpenNoti.base_id] = {
          count: autoOpenNoti.settings.auto_open_popup - 1,
          date: now
        };
        this.openNotiModal(autoOpenNoti);
      }

      localStorage.setItem(NOTI_AUTO_POPUP_LOCAL_STORAGE, JSON.stringify(allAutoOpenNoti));
    },
    async openNotiModal(noti) {
      await this.showModalNoti(noti);
      await this.trackAction(noti);
      noti.state = 1;
      noti.action_count++;
    }
  }
};
</script>

<style lang="scss">
.notification {
  &__container {
    width: 100%;
  }

  &__read-all {
    color: map-get($dark-text, "subtext2");

    &:hover {
      color: map-get($primary, "200");
    }
  }

  &__scroll {
    &.ps {
      max-height: calc(100vh - 128px);
    }
    box-sizing: border-box;
  }
}
</style>
